import React from "react";
import { InvalidMessageContainer, InvalidMessage } from "./StyledErrorMessage";
interface ErrorMessageProps {
  isInRenewPage?: boolean; // Optional boolean
  children: React.ReactNode; // React children
  analyticsId?: string;
  analyticsGroup?: string;
}

const ErrorMessage: React.FC<ErrorMessageProps> = ({
  isInRenewPage = false,
  children,
  analyticsId,
  analyticsGroup,
}) => {
  return (
    <InvalidMessageContainer isInRenewPage={isInRenewPage}>
      <InvalidMessage
        data-analytics-id={analyticsId}
        data-analytics-group={analyticsGroup}
      >
        {children}
      </InvalidMessage>
    </InvalidMessageContainer>
  );
};

export default ErrorMessage;
